module.exports = __webpack_public_path__ + "images/sort-up-down-hover-71145317.svg";